/* global DI */

var angular = require('angular');

var formatZip = require('js/lib/util').formatZip;
var translate = require('js/lib/translate');

addressHelper.$inject = ['$document', 'loadScript'];

function addressHelper($document, loadScript) {
  var config = {
    baseUrl: process.env.ADDRESS_HELPER_URL,
    apiKey: '4nkm+qaIT1roMaf/eo+IkYaQp60B8oGf',
    useGeoLocation: process.env.CONFIG !== 'dev',
    lookOnlyForAddress: true,
    disableHouseholdHelpPanel: true,
    maxResultsDisplayed: 100
  };

  var initAddressHelper = function(element, countryCode, address, onChangeCallback) {
    config.country = countryCode;
    config.limitToOfficial = false;

    var diah = new DI.AddressHelper(element.attr('id'), config);

    try {
      if (address.deliveryPointId) {
        diah.initializeFromDeliverypointId(address.deliveryPointId);
      } else if (address.address) {
        diah.parseStreetAddressAndZipCity(address.address, address.zip, address.city);
      }
    } catch (e) {
      // Hack to enable saving when diah fails:
      // https://jira-di.atlassian.net/browse/DI-15989
      console.log('initAddressHelper error', e, address);
    }

    diah.populateFailedEvent.subscribe(function() {
      angular.element(element[0].querySelectorAll('.streetInput')).val(address.address);
      // TODO populate element[0].querySelectorAll('.streetNumberInput');
      angular.element(element[0].querySelectorAll('.zipLabel')).val(formatZip(address.zip, countryCode));
      angular.element(element[0].querySelectorAll('.cityLabel')).val(address.city);
      onChangeCallback(false, null);
    });

    diah.selectionChangeEvent.subscribe(function() {
      var street = diah.getSelectedAddress().street || {};
      var streetNumber = diah.getSelectedAddress().streetNumber || {};

      if (diah.isComplete() && ! streetNumber.latitude) {
        element.addClass('lat-long-error');
      } else {
        element.removeClass('lat-long-error');
      }

      onChangeCallback(diah.isComplete(), {
        deliveryPointId: streetNumber.deliveryPointId || street.deliveryPointId,
        latitude: streetNumber.latitude,
        longitude: streetNumber.longitude,
        country: countryCode,
        city: street.city,
        zip: parseInt((streetNumber.postalCode || street.postalCode), 10) || null,
        address: [
          (street.streetName || ''),
          ' ',
          (streetNumber.streetNo || ''),
          (streetNumber.entrance || '')
        ].join('').trim(),
        suggestedRoute: null
      });
    });
  };

  // Cancel escape if an autocomplete element is open, to stop the modal from closing
  var initCancelEscape = function(element) {

    var cancelEscape = function(event) {
      if (event.keyCode !== 27) return;

      var acElements = element[0].querySelectorAll('.yui-ac-content');
      var openAcElements = Array.prototype.filter.call(acElements, function(el) {
        return el.offsetHeight;
      });

      if (openAcElements.length) event.stopImmediatePropagation();
    };

    $document.on('keydown', cancelEscape);

    element.on('$destroy', function() {
      $document.off('keydown', cancelEscape);
    });
  };

  return {
    template: require('html/templates/addressHelper'),
    restrict: 'E',
    replace: true,
    scope: {
      countryCode: '=',
      deliveryPointId: '=',
      address: '=',
      zip: '=',
      city: '=',
      onChange: '='
    },

    link: function(scope, element) {
      var address = {
        deliveryPointId: scope.deliveryPointId,
        address: scope.address,
        zip: scope.zip,
        city: scope.city
      };
      scope.t = translate.t;

      loadScript.load('https://www.di.no/addresshelper/diah.js').then(function() {
        initCancelEscape(element);
        initAddressHelper(element, scope.countryCode, address, scope.onChange);
      });
    }
  };

}

module.exports = addressHelper;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/directives/addressHelper.js
 ** module id = 135
 ** module chunks = 1
 **/